import { formatDateForRequest } from "@/utils/utils";

export const getAvailRequestData = (
	state,
	getters,
	packCode,
	startDate = "",
	endDate = ""
) => {
	const dates = state.dates;
	const liheId = state.liheData.id;
	const locale = getters.locale;
	const season = state.season;

	const requestData = { packCode, locale, liheId, season };

	// use provided dates or from state
	if (dates["BeginDate"])
		requestData["startDate"] = formatDateForRequest(dates["BeginDate"]);
	if (dates["EndDate"])
		requestData["endDate"] = formatDateForRequest(dates["EndDate"]);
	if (startDate) requestData["startDate"] = startDate;
	if (endDate) requestData["endDate"] = endDate;
	return requestData;
};

export const getQuoteRequestData = (state, getters, packCode) => {
	const dates = state.dates;
	const liheId = state.liheData.id;
	const locale = getters.locale;
	const travellers = state.participants;
	const season = state.season;

	const requestData = { locale, packCode, travellers, liheId, season };

	if (dates["BeginDate"])
		requestData["startDate"] = formatDateForRequest(dates["BeginDate"]);
	if (dates["EndDate"])
		requestData["endDate"] = formatDateForRequest(dates["EndDate"]);
	return requestData;
};
